import { render } from "./menu-item-group.vue?vue&type=template&id=53f48e08"
import script from "./menu-item-group.vue?vue&type=script&lang=js"
export * from "./menu-item-group.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/RelaxPlus/RelaxPlus/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__